import { JsonFormSchemaV2 } from '../../../FormComponent/types'
import { StatementEditorV2ChapterNode } from '../../types'

export const CREATE_INDEX_NODE_FORM_SCHEMA: JsonFormSchemaV2 = {
  type: 'object',
  required: ['title'],
  properties: [
    {
      id: 'title',
      type: 'string',
      title: 'Title',
      description: 'Display title for the new index item',
    },
    {
      id: 'description',
      type: 'string',
      title: 'Description',
      description: 'Optional metadata for the index item',
      widget: 'textarea',
    },
  ],
}

export function generateIndexNodeId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `index-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function buildNewRootIndexNode(formData: Record<string, unknown>): StatementEditorV2ChapterNode {
  const node: StatementEditorV2ChapterNode = {
    id: generateIndexNodeId(),
    title: String(formData.title ?? ''),
    children: [],
  }

  const description = typeof formData.description === 'string' ? formData.description.trim() : ''
  if (description) {
    node.description = description
  }

  return node
}
